<template>
  <v-dialog
    :model-value="true"
    :retain-focus="false"
    max-width="640"
    persistent
  >
    <section
      class="ra-thanks"
      role="dialog"
      aria-modal="true"
      :aria-label="message.title"
    >
      <h2 class="ra-thanks__title">
        {{ message.title }}
      </h2>
      <p
        v-for="(line, index) in message.body"
        :key="index"
        class="ra-thanks__body"
      >
        {{ line }}
      </p>
      <!-- 陽性・陰性で文面・配色・導線を出し分けない（FR-010）。報告ボタンは双方で表示する。 -->
      <div class="ra-thanks__actions">
        <v-btn
          color="#9e9e9e"
          variant="flat"
          min-width="112"
          @click="emit('close')"
        >
          閉じる
        </v-btn>
        <v-btn
          color="#c8384f"
          variant="flat"
          @click="emit('report-requested')"
        >
          {{ message.reportActionLabel }}
        </v-btn>
      </div>
    </section>
  </v-dialog>
</template>

<script setup lang="ts">
import type { RiskAssessmentCompletionMessage } from "@/vue/entities/risk-assessment";

defineProps<{
  message: RiskAssessmentCompletionMessage;
}>();

const emit = defineEmits<{
  close: [];
  "report-requested": [];
}>();
</script>

<style lang="scss" scoped>
.ra-thanks {
  background-color: #fff;
  border-radius: 4px;
  padding: 48px 32px;
  text-align: center;
}

.ra-thanks__title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
}

.ra-thanks__body {
  font-size: 14px;
  line-height: 1.8;
}

.ra-thanks__actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 28px;
}
</style>
